<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import dayjs from "dayjs";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "sysTask",
      key: "id",
      kv: "",
      selectC: "",
      url: {},
      items: [
        { label: "服务成本", type: "header" },
        {
          label: "医院名称",
          name: "customerId",
          value: "",
          type: "selectDesk",
          width: "400px",
          dropList: [],
          rules: [
            {
              required: true,
            },
          ],
          selected: 0,
          onChange: this.onChangecustomer,
        },
        {
          label: "工程师",
          name: "userId",
          value: "",
          type: "selectDesk",
          width: "400px",
          dropList: [],
          selected: 0,
        },
        {
          label: "工程师（手填）",
          name: "userName",
          value: "",
          type: "input",
          width: "400px",
        },
        {
          label: "综合工资",
          name: "payMoney",
          value: "",
          width: "400px",
          type: "number",
          min: 0,
          rules: [{ required: true }],
          formatter: (value) =>
            `¥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          parser: (value) => value.replace(/\¥\s?|(,*)/g, ""),
        },
        {
          label: "支付日期",
          KeyEnter: this.search,
          name: "monthTime",
          value: dayjs().format("YYYY-MM"),
          width: "400px",
          type: "month",
        },
        {
          label: "备注",
          name: "remark",
          value: "",
          type: "textarea",
          width: "400px",
        },
      ],
      customerId: "",
      customerName: "",
      forms: {
        type: null,
      },
    };
  },
  created() {
    let query = this.$route.query;
    this.loadAdminUserData();
    if (query.action === "add") {
      this.forms.type = query.type;
    }
    if (query.action === "edit") {
      this.kv = query.kv;
      this.initData();
      this.onChangecustomer(query.customerId, true);
    }
  },
  mounted() {},
  methods: {
    async onChangecustomer(id, is) {
      let q = {
        customerId: id,
      };
      let res = await $utils.api.load(
        "/admin/system/maiUser/insCustomerList",
        q
      );
      if (res && res.data) {
        let ll = res.data;
        let dropList = [];
        if (!is) {
          this.forms.userId = "";
        }
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.userId;
          xx.name = element.nickName;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "userId") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    initData() {
      // 加载详情数据
      let id = this.kv;
      $utils.api.load(`/admin/system/payroll/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
          this.onChangecustomer(res.data.customerId, true);
        }
      });
    },
    async handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      await this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(
              `/admin/system/payroll`,
              q,
              this.action == "edit" ? "PUT" : "POST"
            )
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    async loadAdminUserData() {
      let q = {};
      let res = await $utils.api.load("/admin/system/customer/list", q);
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.customerName;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "customerId") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
  },
};
</script>
